/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ElementType {
    Device = 'DEVICE',
    Devicetype = 'DEVICETYPE',
    Devicetypecertificate = 'DEVICETYPECERTIFICATE',
    Devicetypesettings = 'DEVICETYPESETTINGS',
    Firmware = 'FIRMWARE',
    Globalsettings = 'GLOBALSETTINGS',
    Job = 'JOB',
    Loader = 'LOADER',
    Provisioning = 'PROVISIONING',
    Stbgroup = 'STBGROUP',
    Supergroup = 'SUPERGROUP',
    Ui = 'UI',
    Upgraderule = 'UPGRADERULE',
    User = 'USER',
    Rescue = 'RESCUE'
}

export function ElementTypeFromJSON(json: any): ElementType {
    return ElementTypeFromJSONTyped(json, false);
}

export function ElementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementType {
    return json as ElementType;
}

export function ElementTypeToJSON(value?: ElementType | null): any {
    return value as any;
}

